export default {
  default: 'false',
  locale: 'fr',
  cmsLocale: 'fr',
  description: 'French'
};
